import React from 'react'
import { SocietyLayout } from '../../../SocietyLayout'
import { SocietyResidentTicketSideBarContent } from './SocietyResidentTicketSideBarContent'

export const SocietyResidentTicketLayout = (): React.ReactNode => {
  return (
    <SocietyLayout
      noContainer
      sidebar={<SocietyResidentTicketSideBarContent />}
    />
  )
}
